import { fetchWithAuth } from '../lib/fetchWithAuth';

const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type EmployerDashboardKpi = {
  id: string;
  label: string;
  value: string;
  trend: string;
  targetTab?: string;
};

export type EmployerDashboardInsight = {
  id: string;
  title: string;
  value: string;
  description: string;
  highlights: string[];
  icon?: string;
  actionLabel?: string;
  actionLink?: string;
};

export type EmployerDashboardSummary = {
  updatedAt: string;
  kpis: EmployerDashboardKpi[];
  insights: EmployerDashboardInsight[];
};

export async function fetchEmployerDashboardSummary(): Promise<EmployerDashboardSummary> {
  if (!API_BASE_URL) {
    throw new Error('VITE_API_URL is required to load employer dashboard data.');
  }

  try {
    const response = await fetchWithAuth(`${API_BASE_URL}/v1/employer/dashboard`);
    if (!response.ok) {
      throw new Error(`Employer dashboard fetch failed (${response.status})`);
    }
    const payload = (await response.json()) as EmployerDashboardSummary;
    if (!payload?.kpis) {
      throw new Error('Employer dashboard response malformed');
    }
    return payload;
  } catch (error) {
    console.warn('[employer-dashboard] request failed', error);
    throw error instanceof Error ? error : new Error('Unable to load employer dashboard');
  }
}
